import request from '../utils/request'

export function arsLabelListApi (params) {
  return request({
    url: 'api/label/labelList/0',
    method: 'get',
    params
  })
}

export function arsLabelDeleteRelevancyApi (data) {
  return request({
    url: 'api/label/deleteRelevancy',
    method: 'post',
    data
  })
}

export function arsLabelRelevancyAddApi (data) {
  return request({
    url: 'api/label/relevancyAdd',
    method: 'post',
    data
  })
}

export function arsLabelDeleteByIdApi (labelId) {
  return request({
    url: `api/label/deleteById/${labelId}`,
    method: 'post'
  })
}

export function arsLabelAddOrUpdateApi (data) {
  return request({
    url: 'api/label/addOrUpdate',
    method: 'post',
    data
  })
}

export function arsLabelBatchRelevancyAddApi (data) {
  return request({
    url: 'api/label/batchRelevancyAdd',
    method: 'post',
    data
  })
}
